import { Button, Center, Text, ThemeIcon } from "@mantine/core";
import { Logo } from "../../../layouts/Logo";
import { useLanguage } from "../../../stores/LanguageStore";
import { IconCheck } from "@tabler/icons-react";
import { Link } from "react-router-dom";

const EmailAddedPage = () => {
  const lang = useLanguage((s) => s.language);
  const params = new URLSearchParams(window.location.search);
  const emailId = params.get("id");

  return (
    <Center
      w={"60vw"}
      h={"50vh"}
      style={{ flexDirection: "column" }}
      mx={"auto"}
      mt={128}
    >
      <Logo w={200} mb={64} />
      <ThemeIcon size={96} color="green" radius={"xl"} variant="light" mb={16}>
        <IconCheck size={64} />
      </ThemeIcon>
      <Text fz={28} ta={"center"}>
        {lang.emails_account.added_text1} <br />{" "}
      </Text>

      <Button
        size="md"
        mt={"md"}
        component={Link}
        to={`/senders/email/${emailId}`}
      >
        {lang.emails_account.added_text2}
      </Button>
    </Center>
  );
};

export default EmailAddedPage;
